.hero {
    position: relative;
    width: 100%;
    height: calc(100dvh - 85px);
    min-height: 560px;
    margin-top: -25px;
}

.heroImage {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 80%;
    height: 100%;
    object-fit: cover;
    object-position: 0 0;
}

.heroContent {
    position: absolute;
    left: 10%;
    bottom: 56px;
    z-index: 2;
    width: fit-content;
    max-width: 600px;
    padding: 40px;
    background-color: rgba(60, 174, 176, 0.72);
    display: block;
    box-sizing: border-box;
}

.heroContentText {
    overflow-wrap: normal;
    word-break: normal;
    hyphens: none;
    color: #FFFFFF;
    font-weight: 700;
    font-size: 70px;
    line-height: 1.1;
    letter-spacing: 0.5px;
    margin: 0 0 25px;
}

.heroCta {
    display: inline-block;
    width: auto;
}

@media (min-width: 1141px) {
    .heroContentText:lang(es) {
        font-size: 62px;
    }
}

.heroCta a {
    display: inline-block;
    height: 50px;
    line-height: 50px;
    padding: 0 38px;
    font-size: 15px;
}

@media (max-width: 1140px) {
    .heroContentText {
        font-size: 62px;
    }
}

@media (max-width: 960px) {
    .heroImage {
        width: 100%;
    }

    .heroContent {
        left: 5%;
        width: 90%;
        max-width: 100%;
    }
}

@media (max-width: 768px) {
    .hero {
        height: auto;
        min-height: 0;
        margin-top: -25px;
    }

    .heroContentText {
        color: #3caeb0;
        font-size: clamp(28px, 8.5vw, 40px);
        line-height: 1.1;
    }

    .heroImage {
        position: relative;
        height: 600px;
        display: block;
        /* Keep the child's face in view when the landscape photo is cropped. */
        object-position: 65% 0;
    }

    .heroContent {
        position: relative;
        left: auto;
        bottom: auto;
        width: 100%;
        padding: 25px;
        background-color: rgba(60, 174, 176, 0.3);
        border-bottom: 1px solid rgba(60, 174, 176, 0.23);
        text-align: center;
    }

    .heroCta a {
        padding: 0 25px;
        font-size: 14px;
    }
}

@media (max-width: 480px) {
    .heroImage {
        height: 375px;
    }
}
